export default function mmToPixel(mm, dotsPerMM) {
  if (typeof mm === "number") {
    return mm * (dotsPerMM || 8);
  }
}
